window.open = function (open) {
    return function (url, name, features) {
        if (name === 'stripe_checkout_tabview') return;  // Block stripe popup to prevent popup blocker
        return open.call(window, url, name, features);
    };
}(window.open);

// Capture fbclid (Meta ad click id) from the URL so it survives navigation
// across the checkout/signup flow.
(function captureFbclid() {
  var m = /[?&]fbclid=([^&]+)/.exec(location.search);
  if (m) {
    try { window.sessionStorage.setItem('ha_fbclid', decodeURIComponent(m[1])); } catch (ex) { /* sessionStorage blocked */ }
  }
})();

window.jQuery(function() {
  var stripeModalIcon = 'https://idx.homeasap.com/wp-content/uploads/2017/05/idx-logo-square-copy-1.png';

  var autoAccessToken = ''
  var justRegistered = false
  window.homeasapTest = window.location.href.indexOf('test') > -1 || window.location.href.indexOf('dev') > -1;
  var apiRoot = 'https://api.' + (window.homeasapTest ? 'test' : '') + 'homeasap.com/NPlay.Services.NPlayApi/api/';
  var stripeAPIKey = window.homeasapTest && 'pk_test_XIP3mD3HBmuIkv8QAs3vD7KL' || 'pk_live_jQEkbJ6Zcj72iIiNHlLoeYDh';
  var openRedirectUrl = function() {
    var url = 'https://idx.homeasap.com/page-create/?redirectUrl=' + encodeURIComponent('https://dashboard.' + (window.homeasapTest ? 'test' : '') + 'homeasap.com/Directory/Account/Login?SkipNew=1' 
      + '&ReturnUrl=' + encodeURIComponent('/Directory/Agent/Edit?section=2')
      + '&token=' + autoAccessToken);
    console.log('go to', url);
    window.location.href = url;
  }
  var simForm = window.jQuery('form.simpay-checkout-form');
  var mlsId = (getUrlParameter('mlsid') || '').trim();
  if (!mlsId && (document.referrer || '').indexOf('mlsid') > -1) {
     mlsId = (getUrlParameter('mlsid', new URL(document.referrer).search) || '').trim();
  }

  if (!simForm || !mlsId) {
    return;
  }
  
  if (!location.search) {
    localStorage.removeItem('LocalStorage-QueryString-1');
  }
    
  var planId = simForm.find('input[name=simpay_field\\[hidden-plan-id\\]]').val()
  
  if (!planId || !planId.match(/^\d+$/)) {
    return;
  }
  
  window.jQuery.ajax({
    url: apiRoot + "mls/" + mlsId,
    type: "GET",
    dataType: 'json',
    crossDomain: true,
    success: function(data) {
      if (data && data.Name) {
        var mlsName = data.Name;
        window.jQuery('.mls-name').text(mlsName);
        initiateHomeASAPOverride();
      }
    },

    error: function(jqXHR, status, thrownError) {
      
    }
  });

  function initiateHomeASAPOverride () {
    var guid = '';
    try {
      guid = window.sessionStorage.getItem('guid');
      window.sessionStorage.removeItem('guid');
    } catch (ex) {}
    if (getUrlParameter('guid') || guid) {
      autoAccessToken = getUrlParameter('guid') || guid;
      if (!autoAccessToken.match(/^ha/)) {
        autoAccessToken = 'ha-aa_' + autoAccessToken;
      }
      authAPI(autoAccessToken, true, {duplicatingAgent: true}, function(data) {
        simForm.find('button.simpay-payment-btn')
          .off('click.simpayPaymentBtn')
          .on('click.simpayPaymentBtn', function(e) {
          e.preventDefault();
          e.stopPropagation();

          register({ duplicateAgentId: data.AgentId });
        });
      });
    } else {
      // homeasap detection 
      var agentDataIFrame = document.createElement('iframe')
      agentDataIFrame.src = "https://" + (window.homeasapTest ? 'test' : '') + "homeasap.com/iframe-detect-agent.html?origin=" + window.location.origin;
      agentDataIFrame.style.width = "0"
      agentDataIFrame.style.height = "0"
      agentDataIFrame.style.position = "absolute"
      agentDataIFrame.style.top = "-10000px"
      document.body.appendChild(agentDataIFrame)

      window.addEventListener("message", function (e) {
        if (typeof e.data === 'string') {
          if (e.data.match(/^HOMEASAP_DETECT_AGENT:SUCCESS::/)) {
            autoAccessToken = e.data.replace('HOMEASAP_DETECT_AGENT:SUCCESS::', '').replace(/^"/, '').replace(/"$/, '');
            authAPI(autoAccessToken, true);
          } else if (e.data.match(/^HOMEASAP_DETECT_AGENT:FAILED::/)) {
            simForm.find('button.simpay-payment-btn')
            .off('click.simpayPaymentBtn')
            .on('click.simpayPaymentBtn', function(e) {
              e.preventDefault();
              e.stopPropagation();

              register();
            })
          }
        }
      }, false)
    }
    
    function readFbclid() {
      var m = /[?&]fbclid=([^&]+)/.exec(location.search);
      if (m) return decodeURIComponent(m[1]);
      try {
        return window.sessionStorage.getItem('ha_fbclid') || null;
      } catch (ex) { /* sessionStorage blocked */ }
      return null;
    }

    function register(opts) {
      opts = opts || {};

      var data = {
        firstName: simForm.find('input[name=simpay_field\\[first-name\\]]').val(),
        lastName: simForm.find('input[name=simpay_field\\[last-name\\]]').val(),
        email: simForm.find('input[name=simpay_field\\[email\\]]').val(),
      }
      var fbclid = readFbclid();
      if (fbclid) data.fbclid = fbclid;
      data.eventSourceUrl = window.location.href;

      if (opts.duplicateAgentId) {
        data.email = data.email.replace(/[@]/g, '==') + '@userid.' + opts.duplicateAgentId + '.' + (new Date().getTime()) + '.home.asap';
      }

      if (!data.firstName || !data.lastName || !data.email) {
        return showErrorDialog('Please input your first name, last name, and email.');
      }
      
      showLoading();

      window.jQuery.ajax({
        url: apiRoot + "register/auto",
        type: "POST",
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: data,
        success: function(data) {
          justRegistered = true;
          authAPI(data, true, {}, function() {
             window.jQuery.ajax({
              url: apiRoot + "agentautoauth",
              type: "GET",
              dataType: 'json',
              xhrFields: {
                withCredentials: true
              },
              crossDomain: true,
              success: function(data) {
                autoAccessToken = data; 
              },
              error: function() {
              }
            });
          });
        },

        error: function(jqXHR, status, thrownError) {
          hideLoading();
          simForm.find('button.simpay-payment-btn').off('click.simpayPaymentBtn');
          
          var simpayData = simpayApp.spFormData[ simForm.data("simpay-form-id") ];
          var stripeObj = StripeCheckout.configure({
            key: simpayData.stripeParams.key,
            token: function(i, p) {
              !function(i, p) {
                var s = simForm.find("." + simpayData.submitBtnClass);
                window.jQuery("<input>").attr({
                  type: "hidden",
                  name: "simpay_stripe_token",
                  value: i.id
                }).appendTo(simForm), window.jQuery("<input>").attr({
                  type: "hidden",
                  name: "simpay_stripe_email",
                  value: i.email
                }).appendTo(simForm), p && simpayApp.handleStripeShippingArgs(simForm, p);
                s.prop("disabled", !0).find("span").text(simpayData.loadingText), simForm.off("submit"), simForm.submit()
              }(i, p)
            },
            opened: function() {},
            closed: function() {}
          })
          simForm.find(".simpay-payment-btn").on("click.simpayPaymentBtn", function(i) {
            i.preventDefault(), simpayData.isValid = !0, simForm.trigger("simpayBeforeStripePayment", [simForm, simpayData]), simpayData.isValid && (simpayApp.setCoreFinalAmount(simForm, simpayData), simpayData.stripeParams.amount = spShared.convertToCents(simpayData.finalAmount), simForm.find(".simpay-amount").val(simpayData.stripeParams.amount), stripeObj.open(simpayData.stripeParams))
          })
          simForm.find('button.simpay-payment-btn').trigger('click.simpayPaymentBtn');
        }
      });
    }

    function authAPI(token, isDetected, opts, callback) {
      opts = opts || {};
      console.log('Welcome!  Fetching your information.... ');

      window.jQuery.ajax({
        url: apiRoot + "agentauth",
        type: "POST",
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: {
          '': token
        },
        success: function(data) {
          callback ? callback(data) : '';
          agentAPI(opts);
        },

        error: function(jqXHR, status, thrownError) {
          
        }
      });
    }

    function agentAPI(opts) {
      opts = opts || {};
      
      window.jQuery.ajax({
        url: apiRoot + "agent",
        type: "GET",
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        success: function(data) {
          console.log("Agent login successful", data)

          simForm.find('input[name=simpay_field\\[first-name\\]]').val(data.firstName).attr('data-fetched', data.firstName);
          simForm.find('input[name=simpay_field\\[last-name\\]]').val(data.lastName).attr('data-fetched', data.lastName);
          var cleanedEmail = data.email.match(/@userid\./gi) ? data.email.split('@')[0].replace('==', '@') : data.email
          simForm.find('input[name=simpay_field\\[email\\]]').val(cleanedEmail).attr('data-fetched', data.email);

          if (data.accountInReview) {
            console.log("Account In Review");
            return;
          }

          if (!opts.duplicatingAgent) {
            hookUpButton();
          }
        },

        error: function() {

        }
      });
    }

    var stripeJSHandler = StripeCheckout.configure({
      key: stripeAPIKey,
      image: stripeModalIcon,
      token: function (token) {
        showLoading();
        addCard(token.id);
      }
    });

    function hookUpButton() {
      simForm.find('button.simpay-payment-btn')
      .off('click.simpayPaymentBtn')
      .on('click.simpayPaymentBtn', function(e) {
        e.preventDefault();
        e.stopPropagation();

        hideLoading();
        stripeJSHandler.open({
            name: 'IDX Home Search',
            description: 'Annual Plan | No Contracts',
            panelLabel: 'Pay',
            email: simForm.find('input[name=simpay_field\\[email\\]]').val(),
            zipCode: true,
            allowRememberMe: false
        });
      });

      if (justRegistered) {
        simForm.find('button.simpay-payment-btn').trigger('click.simpayPaymentBtn');
      }
    }

    function addCard(tokenId) {
      window.jQuery.ajax({
        url: apiRoot + "agent/creditcard",
        type: "POST",
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: {
          '': tokenId
        },
        success: function(data) {
          // Make Purchase
          if (data && data.length > 0) {
            console.log('Card Added')
            var newlyAddedCardId = data[0].Id;
            makePurchase(newlyAddedCardId);
          } else {
            hideLoading();
            showErrorDialog('Could not complete purchase.');
          }
        },

        error: function() {
          hideLoading();
          showErrorDialog('Could not complete purchase.');
        }
      });
    }

    function makePurchase(cardId) {
      var couponCode = simForm.find('input[name=simpay_coupon]').val();
      if (!planId) {
        hideLoading();
        showErrorDialog('Plan not setup.');
        console.log('Marketing: Add plan to the dictionary on top of the script');
      }

      window.jQuery.ajax({
        url: apiRoot + "cart",
        type: "POST",
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: {
          productPlanIds: [planId], 
          couponCode: couponCode, 
          promoCode: couponCode, 
          selectedCardId: cardId,
          mlsId: mlsId,
        },
        success: function(data) {
          console.log(data)
          var productPlan = data && data.productPlans && data.productPlans[0];
          
          if (productPlan && productPlan.created) {
            window.jQuery.ajax({
              url: apiRoot + "agent/mls",
              type: "PUT",
              dataType: 'json',
              xhrFields: {
                withCredentials: true
              },
              crossDomain: true,
              data: {
                mlsOrgId: mlsId,
              }
            }).always(function() {
              hideLoading();
              openRedirectUrl();
            });
            
          } else if (productPlan && productPlan.errorMessage) {
            hideLoading();
            showErrorDialog(productPlan.errorMessage)
          } else {
            hideLoading();
            showErrorDialog("Failed to purchase the service.");
          }
        },

        error: function(jqXHR, status, thrownError) {
          hideLoading();
          console.log(arguments)
          if (jqXHR.responseText.indexOf('User already has registered service') > -1) {
            showErrorDialog("You already have service.");
          } else {
            showErrorDialog("Failed to purchase the service.");
          }
        }
      });

    }
  }

  var loadingTime = null;

  function showLoading() {
    var loading = window.jQuery('#loading-mask');
    if (loading.length === 0) {
      loading = window.jQuery('<div id="loading-mask"><div id="loading-center"><div id="loading-center-absolute"><div id="object"></div></div></div><style>#loading-mask{display:none}#loading-mask.on{display:block;background-color:rgba(0,0,0,.6);height:100%;width:100%;position:fixed;z-index:10000;margin-top:0;top:0}#loading-center{width:100%;height:100%;position:relative}#loading-center-absolute{position:absolute;left:50%;top:50%;height:200px;width:200px;margin-top:-100px;margin-left:-100px}#object{width:80px;height:80px;background-color:#FFF;background-image:url("' + stripeModalIcon + '");background-size:100% 100%;-webkit-animation:animate 2s infinite ease-in-out;animation:animate 2s infinite ease-in-out;margin-right:auto;margin-left:auto;margin-top:60px}@-webkit-keyframes animate{0%{-webkit-transform:perspective(160px) rotateX(0) rotateY(0);transform:perspective(160px) rotateX(0) rotateY(0)}25%{-webkit-transform:perspective(160px) rotateX(-180deg) rotateY(0);transform:perspective(160px) rotateX(-180deg) rotateY(0)}50%{-webkit-transform:perspective(160px) rotateX(-180deg) rotateY(-180deg);transform:perspective(160px) rotateX(-180deg) rotateY(-180deg)}75%{-webkit-transform:perspective(160px) rotateX(-360deg) rotateY(-180deg);transform:perspective(160px) rotateX(-360deg) rotateY(-180deg)}100%{-webkit-transform:perspective(160px) rotateX(-360deg) rotateY(-360deg);transform:perspective(160px) rotateX(-360deg) rotateY(-360deg)}}@keyframes animate{0%{-webkit-transform:perspective(160px) rotateX(0) rotateY(0);transform:perspective(160px) rotateX(0) rotateY(0)}25%{-webkit-transform:perspective(160px) rotateX(-180deg) rotateY(0);transform:perspective(160px) rotateX(-180deg) rotateY(0)}50%{-webkit-transform:perspective(160px) rotateX(-180deg) rotateY(-180deg);transform:perspective(160px) rotateX(-180deg) rotateY(-180deg)}75%{-webkit-transform:perspective(160px) rotateX(-360deg) rotateY(-180deg);transform:perspective(160px) rotateX(-360deg) rotateY(-180deg)}100%{-webkit-transform:perspective(160px) rotateX(-360deg) rotateY(-360deg);transform:perspective(160px) rotateX(-360deg) rotateY(-360deg)}}</style></div>').appendTo('body');
    }
    loading.addClass('on');
    loadingTime = new Date().getTime();
  }

  function hideLoading() {
    var loading = window.jQuery('#loading-mask');
    if (loading.length > 0) {
      if (!loadingTime || new Date().getTime() - loadingTime > 1000) {
        loading.removeClass('on');
      } else {
        setTimeout(function() {
          window.jQuery('#loading-mask').removeClass('on');
        }, 500)
      }
      loadingTime = null;
    }
  }

  function showErrorDialog(message) {
    var dialog = window.jQuery('#error-dialog');
    if (dialog.length === 0) {
      dialog = window.jQuery('<div id="error-dialog" title="Oh Shucks!"></div>').appendTo('body');
    }
    dialog.html(message);
    if (dialog.dialog) {
      dialog.dialog({autoOpen: true});
    } else {
      alert(message);
    }
  }

  function getUrlParameter(name, searchString) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(searchString || location.search || localStorage.getItem('LocalStorage-QueryString-1') || '');
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };
})
